import { Link } from 'react-router-dom';
import { categories } from '@/mocks/siteData';

const categoryImages: Record<string, string> = {
  tutorial: 'https://readdy.ai/api/search-image?query=Modern%20minimalist%20educational%20tutorial%20guide%20illustration%20with%20clean%20warm%20lighting%2C%20flat%20design%20style%2C%20soft%20cream%20background%2C%20learning%20concept%20with%20subtle%20geometric%20shapes%2C%20editorial%20quality%2C%20professional%20aesthetic&width=600&height=300&seq=cat-tutorial&orientation=landscape',
  security: 'https://readdy.ai/api/search-image?query=Modern%20minimalist%20security%20protection%20illustration%20with%20clean%20warm%20lighting%2C%20flat%20design%20style%2C%20soft%20cream%20background%2C%20shield%20concept%20with%20subtle%20geometric%20shapes%2C%20editorial%20quality%2C%20professional%20aesthetic&width=600&height=300&seq=cat-security&orientation=landscape',
  news: 'https://readdy.ai/api/search-image?query=Modern%20minimalist%20news%20announcement%20illustration%20with%20clean%20warm%20lighting%2C%20flat%20design%20style%2C%20soft%20cream%20background%2C%20megaphone%20concept%20with%20subtle%20geometric%20shapes%2C%20editorial%20quality%2C%20professional%20aesthetic&width=600&height=300&seq=cat-news&orientation=landscape',
  sports: 'https://readdy.ai/api/search-image?query=Modern%20minimalist%20sports%20event%20illustration%20with%20clean%20warm%20lighting%2C%20flat%20design%20style%2C%20soft%20cream%20background%2C%20trophy%20concept%20with%20subtle%20geometric%20shapes%2C%20editorial%20quality%2C%20professional%20aesthetic&width=600&height=300&seq=cat-sports&orientation=landscape',
};

export default function CategorySection() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900">
            内容分类导航
          </h2>
          <p className="mt-3 text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
            按主题浏览，快速找到您需要的信息
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group relative rounded-xl overflow-hidden bg-background-50 border border-background-200/60 hover:border-primary-300 transition-all duration-300 cursor-pointer"
            >
              <div className="relative h-40 overflow-hidden">
                <img
                  src={categoryImages[cat.slug]}
                  alt={cat.name}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent"></div>
                <div className="absolute bottom-3 left-4 right-4 flex items-center gap-2">
                  <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-50/90 text-primary-600">
                    <i className={`${cat.icon} text-base`}></i>
                  </div>
                  <span className="text-background-50 font-semibold text-sm whitespace-nowrap">
                    {cat.name}
                  </span>
                </div>
              </div>
              <div className="p-4">
                <p className="text-xs text-foreground-600 leading-relaxed line-clamp-2">
                  {cat.description}
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}